import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  FireOutlined,
} from '@ant-design/icons';
import { Flex, Progress, theme, Typography } from 'antd';
import { PreSalesQuestion } from '../../../dto/model';
import { strings } from '../../../lang';
import { PreSalesAnswers } from '../../../utils/pre-sales-questionnaire-evaluator';
import { getPreSalesLiveHeatLoadProgress } from './pre-sales-live-heat-load-utils';

const { Text } = Typography;

type PreSalesLiveHeatLoadProgressBarProps = {
  percent: number;
};

export const PreSalesLiveHeatLoadProgressBar = ({
  percent,
}: PreSalesLiveHeatLoadProgressBarProps) => {
  const { token } = theme.useToken();

  return (
    <Flex vertical gap={2} style={{ minWidth: 0 }}>
      <Flex align="center" justify="space-between" gap={12}>
        <Text strong style={{ color: token.colorWarning }}>
          <FireOutlined aria-hidden />{' '}
          {strings.preSalesQuestionnaire.heatLoadReady}
        </Text>
        <Text>{percent}%</Text>
      </Flex>
      <Progress
        aria-label={strings.preSalesQuestionnaire.heatLoadProgressLabel(percent)}
        percent={percent}
        showInfo={false}
        size="small"
        status="active"
        strokeColor={token.colorWarning}
      />
    </Flex>
  );
};

type PreSalesLiveHeatLoadStatusProps = {
  answers: PreSalesAnswers;
  visibleQuestions: PreSalesQuestion[];
  isLiveHeatLoadCancellation: boolean;
};

export const PreSalesLiveHeatLoadStatus = ({
  answers,
  visibleQuestions,
  isLiveHeatLoadCancellation,
}: PreSalesLiveHeatLoadStatusProps) => {
  const { token } = theme.useToken();
  const percent = Math.round(
    getPreSalesLiveHeatLoadProgress(answers, visibleQuestions),
  );

  if (percent < 100) {
    return <PreSalesLiveHeatLoadProgressBar percent={percent} />;
  }

  if (isLiveHeatLoadCancellation) {
    return (
      <Flex align="center" gap={8} style={{ color: token.colorError, minHeight: 28 }}>
        <CloseCircleOutlined aria-hidden />
        <Text strong type="danger">{strings.preSalesQuestionnaire.heatLoadCancellation}</Text>
      </Flex>
    );
  }

  return (
    <Flex align="center" gap={8} style={{ color: token.colorSuccess, minHeight: 28 }}>
      <CheckCircleOutlined aria-hidden />
      <Text strong type="success">{strings.preSalesQuestionnaire.heatLoadValid}</Text>
    </Flex>
  );
};
